import {AppController} from "@ok/web/modules/block/AppController";
import {ToastManagerStore} from "./ToastManagerStore";
import {action} from "mobx";
import {IToast} from "@ok/web/interfaces/ToastTypes";

export class ToastManagerController extends AppController<ToastManagerStore> {
    public attachToEventBuses = () => {
        window.OK.toastManagerBuses.showToast.attach(this.addToast);
        window.OK.toastManagerBuses.pushToasts.attach(this.addMultipleToasts);
        window.OK.toastManagerBuses.init.trigger();
    };

    public detachFromEventBuses = () => {
        window.OK.toastManagerBuses.showToast.detach(this.addToast);
        window.OK.toastManagerBuses.pushToasts.detach(this.addMultipleToasts);
    };

    @action
    addToast = ({ toast }: { toast: IToast }) => {
        this.store.addToast(toast);
    };

    @action
    addMultipleToasts = ({ toasts }: { toasts: IToast[] }) => {
        this.store.addMultipleToasts(toasts);
    };
}
